// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete {
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
}

.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-left: 15px;
  width: 95%;
}

.noResult {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.noData {
  text-align: center;
  margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/copia-presenze/copia-presenze.page.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;AAAJ","sourcesContent":["\n.autocomplete {\n    margin-top: 10px;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n.footer {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n    margin-left: 15px;\n    width: 95%;\n}\n\n.noResult {\n    display: flex;\n    justify-content: center;\n    margin-top: 50px;\n}\n\n.noData {\n    text-align: center;\n    margin-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
